module.exports = __webpack_public_path__ + "img/vertical_bar_chart.6ee93fc4.png";